// Menu items shown for channels that send styled HTML (email; new-conversation
// editor in HTML mode). The renderer for those messages preserves inline
// styles, so colour/font/underline make sense.
export const RICH_MESSAGE_EDITOR_MENU_OPTIONS = [
  'strong',
  'em',
  'underline',
  'headingLevel',
  'fontSize',
  'textColor',
  'backgroundColor',
  'link',
  'undo',
  'redo',
  'bulletList',
  'orderedList',
  'code',
];

// Default for plain-text channels (WhatsApp, SMS, web widget, …). Styling
// marks are omitted because the recipient client would show the raw HTML.
export const MESSAGE_EDITOR_MENU_OPTIONS = [
  'strong',
  'em',
  'link',
  'undo',
  'redo',
  'bulletList',
  'orderedList',
  'code',
];

// Welcome tagline of the website widget. The widget renders it as markdown.
export const WIDGET_BUILDER_EDITOR_MENU_OPTIONS = [
  'strong',
  'em',
  'link',
  'undo',
  'redo',
];

export const MESSAGE_SIGNATURE_EDITOR_MENU_OPTIONS = [
  'strong',
  'em',
  'underline',
  'headingLevel',
  'fontSize',
  'textColor',
  'backgroundColor',
  'link',
  'undo',
  'redo',
  'imageUpload',
];

export const ARTICLE_EDITOR_MENU_OPTIONS = [
  'strong',
  'em',
  'underline',
  'h1',
  'h2',
  'h3',
  'textColor',
  'backgroundColor',
  'link',
  'undo',
  'redo',
  'bulletList',
  'orderedList',
  'blockquote',
  'imageUpload',
  'code',
  // Toolbar button to insert a raw-HTML block (html_embed). Only renders when the
  // schema defines the node (article schema). Article editing is admin-only.
  'htmlEmbed',
  // Toolbar button to drop a named in-page anchor (#jump target). Only renders
  // when the schema defines the anchor node (article schema).
  'anchor',
];

export const MESSAGE_EDITOR_IMAGE_RESIZES = [
  {
    key: 'SMALL',
    height: '150px',
    width: '200px',
  },
  {
    key: 'MEDIUM',
    height: '300px',
    width: '320px',
  },
  {
    key: 'LARGE',
    height: '500px',
    width: '640px',
  },
  {
    key: 'ORIGINAL',
    height: 'auto',
    width: null,
  },
];

// Presets for the knowledge-base article editor. Each applies a responsive
// `width: 100%; max-width: <width>` so the image fills the column up to the cap
// (and scales down on narrow screens). ORIGINAL clears the size.
export const ARTICLE_EDITOR_IMAGE_RESIZES = [
  {
    key: 'SMALL',
    width: '200px',
  },
  {
    key: 'MEDIUM',
    width: '320px',
  },
  {
    key: 'LARGE',
    width: '640px',
  },
  {
    key: 'ORIGINAL',
    width: null,
  },
];
